import React from 'react';
import { bool, string } from 'prop-types';
import { Box, Typography } from '@mui/material';
import LowPriorityRoundedIcon from '@mui/icons-material/LowPriorityRounded';
import { LowPriorityRoundedNull } from 'library';
import { ProductIndicatorBadge } from 'common';

const iconStyles = theme => ({
  alignSelf: 'end',
  color: theme.palette.primary.light,
  justifySelf: 'end',
  marginRight: '-2px',
  transform: 'rotate(180deg)',
});

const CardHeader = ({ proprietary, sequenced, subtitle, title }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplate: 'repeat(2, 1fr) / 5fr 1fr',
      }}
    >
      <Typography noWrap variant="h6">
        {title}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifySelf: 'end',
        }}
      >
        <ProductIndicatorBadge
          proprietary={proprietary}
          sx={{
            // need a marginRight of 6px for 16px spacing between ellipses and badge
            margin: 'auto 6px auto 0',
          }}
        />
      </Box>
      <Typography
        sx={{
          alignSelf: 'end',
        }}
        variant="body2"
      >
        {subtitle}
      </Typography>
      {sequenced ? (
        <LowPriorityRoundedIcon
          sx={{
            alignSelf: 'end',
            color: 'primary.light',
            justifySelf: 'end',
            marginRight: '-2px',
            transform: 'rotate(180deg)',
          }}
        />
      ) : (
        <LowPriorityRoundedNull sx={iconStyles} />
      )}
    </Box>
  );
};

CardHeader.propTypes = {
  proprietary: bool,
  sequenced: bool.isRequired,
  subtitle: string,
  title: string,
};

CardHeader.defaultProps = {
  proprietary: null,
  subtitle: null,
  title: null,
};

export default CardHeader;
